import React, { useEffect, useState } from 'react';
import { Player, PlayerEvent } from '@lottiefiles/react-lottie-player';
import CloseIcon from '@svg/x-icon.svg?react';
import Maximize from '@svg/maximize.svg?react';
import Minimize from '@svg/minimize.svg?react';
import greetingAnimation from '@assets/lottie/andi_greeting_dev.json';
import idleAnimation from '@assets/lottie/andi_idle_dev.json';

interface ChatHeaderProps {
    isOpen: boolean;
    isInitial: boolean;
    isMaximized: boolean;
    toggleMaximize: () => void;
    toggleChat: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({isOpen, isInitial, isMaximized, toggleMaximize, toggleChat}) => {
    const [greetingDone, setGreetingDone] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setGreetingDone(false);
        }
    }, [isOpen]);

    const closeButton = <button type="button" className="close-button" aria-label="Close chat" onClick={toggleChat}><CloseIcon/></button>;

    if (isInitial) {
        return (
            <>
                {closeButton}
                <div className="chat-header-icon-container">
                    <Player
                        className="chat-header-icon"
                        src={greetingDone ? idleAnimation : greetingAnimation}
                        autoplay
                        loop={greetingDone}
                        style={{width: 80, height: 80}}
                        onEvent={(event: PlayerEvent) => {
                            if (event === PlayerEvent.Complete && !greetingDone) {
                                setGreetingDone(true);
                            }
                        }}
                    />
                </div>
                <span className="bold">Hi, I'm Andi. How can I help?</span>
            </>
        );
    }
    
    return (
        <>
            <span className="bold">Andi</span>
            <div className="chat-header-actions">
                <button type="button" className="maximize-minimize" aria-label={isMaximized ? 'Minimize' : 'Maximize'} onClick={toggleMaximize}>{isMaximized ? <Minimize/> :
                    <Maximize/>}</button>
                {closeButton}
            </div>
        </>
    );
};
